import React from 'react';
import './notice.css';

// Feature-flagged demo banner. Set REACT_APP_DEMO_MODE=false in .env (and
// rebuild) to hide it for production launch without a code change.
const DEMO_MODE = process.env.REACT_APP_DEMO_MODE !== 'false';

const Notice = () => {
    if (!DEMO_MODE) return null;
    return (
        <div className='notice'>
            <p>Notice: This is a demo website. Orders will not be fulfilled.</p>
        </div>
    )
}

export default Notice;
